var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('baseBreadcrumb',{attrs:{"page":_vm.$t('message.orderConfirmation'),"menu":_vm.$t('message.orderForm')}}),_c('orderMain',{attrs:{"status":"21"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }